var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-classic"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M38.54 27.22c.37-8.18 2.79-22.7 2.79-22.7a1.52 1.52 0 0 0 0-.2 1.49 1.49 0 0 0-.52-1.13L40.7 3l-.2-.14C38.12 1.44 31.61 0 24 0 16.12 0 9.42 1.54 7.3 3a1.49 1.49 0 0 0-.63 1.22 1.47 1.47 0 0 0 0 .16v.11c.28 1.58 2.54 15.01 2.9 22.73C3.74 28.76 0 31 0 34.47 0 40.91 9 48 24 48s24-7.06 24-13.53c0-3.47-3.74-5.65-9.46-7.25zm-.22 6.35c-3 5.87-13.68 5.6-14.38 5.6s-11.3.18-14.35-5.68v-5.24c4.77 4.18 14.43 4 14.43 4s9.35.33 14.43-4z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});